<template>
  <div class="bind-ticket white-bg">
    <img class="logo" src="https://resource.rcclchina.com.cn/logo/MB/logoAnchorBlue.png" alt="">
    <div class="form-box">
      <ValidationObserver ref="form">
        <div class="form-item" @click="screenTypeShow = true">
          <div class="icon">
            <img src="../assets/icons/icon_ticket3.png" alt="">
          </div>
          <p class="text">{{screenType[screenTypeChoosed].name}}</p>
          <van-icon class="arrow-down" name="arrow-down" />
        </div>
        <div class="form-item" @click="shipChooseShow = true">
          <div class="icon">
            <img src="../assets/icons/icon_ship.png" alt="">
          </div>
          <p class="text">{{shipName}}</p>
          <van-icon class="arrow-down" name="arrow-down" />
        </div>
        <div class="form-item" @click="datePickerShow = true">
          <div class="icon">
            <img src="../assets/icons/icon_clock.png" alt="">
          </div>
          <input class="text" type="text" readonly v-model="sailDate" placeholder="出航日期">
          <van-icon class="arrow-down" name="arrow-down" />
        </div>
        <div v-if="screenTypeChoosed === 1" class="form-item" @click="birthdayPickerShow = true">
          <div class="icon">
            <img src="../assets/icons/icon_birth.png" alt="">
          </div>
          <input class="text" type="text" readonly v-model="dateOfBirth" placeholder="出生日期" />
          <van-icon class="arrow-down" name="arrow-down" />
        </div>
        <ValidationProvider v-if="screenTypeChoosed === 1" name="舱房号" rules="required" v-slot="{ errors }">
          <div :class="['form-item', {error: errors.length}]">
            <input class="ipt" type="text" placeholder="请输入舱房号" v-model="stateroomNumber">
            <span class="error">{{errors[0]}}</span>
          </div>
        </ValidationProvider>
        <ValidationProvider v-if="screenTypeChoosed === 0" name="订单号" rules="required" v-slot="{ errors }">
          <div :class="['form-item', {error: errors.length}]">
            <input class="ipt" type="text" placeholder="请输入订单号" v-model="bookingId">
            <span class="error">{{errors[0]}}</span>
          </div>
        </ValidationProvider>
        <ValidationProvider name="订票人姓氏" rules="required|english" v-slot="{ errors }">
          <div :class="['form-item', {error: errors.length}]">
            <input class="ipt" type="text" placeholder="请输入订票人姓氏 例“ZHANG”" v-model="lastName" @input="lastNameInput">
            <span class="error">{{errors[0]}}</span>
          </div>
        </ValidationProvider>
      </ValidationObserver>
      <div class="btn-common" @click="onSubmit">提交资料</div>
    </div>
    <!-- 查询类型 -->
    <custom-picker title="选择查询方式" :columns="screenType" :visible.sync="screenTypeShow" @change="screenTypeConfirm" />
    <!-- 查询船只 -->
    <custom-picker :visible.sync="shipChooseShow" @change="shipCode = arguments[0]" />
    <!-- 出航日期 -->
    <base-date-picker title="选择出航日期" :visible.sync="datePickerShow" :value.sync="sailDate" />
    <!-- 生日 -->
    <base-date-picker :visible.sync="birthdayPickerShow" :value.sync="dateOfBirth" :min-date="minDate" />
    <!-- 重新选择舱房 -->
    <change-booking-record-models :show.sync="miniappShow" />
  </div>
</template>

<script>
import { shipList } from '@/utils/dict'
import dayjs from 'dayjs'
import api from '@/api'
import { showLoading, hideLoading, showAlert, showToast } from '@/utils/tools'
import pick from 'lodash/pick'
import CustomPicker from '@/components/CustomPicker'
import BaseDatePicker from '@/components/BaseDatePicker'
import ChangeBookingRecordModels from '@/components/ChangeBookingRecordModels'
import { getShoppingCartNum } from '@/plugins/common'

const screenType = [
  {
    name: '按船票订单查询',
    value: 0
  }, {
    name: '按舱房号查询',
    value: 1
  }
]
export default {
  name: 'PageBindTicket',

  components: {
    CustomPicker,
    BaseDatePicker,
    ChangeBookingRecordModels
  },

  data () {
    const isDevelop = process.env.NODE_ENV === 'development'
    return {
      screenType,
      screenTypeShow: false,
      screenTypeChoosed: 0,
      shipChooseShow: false,
      shipCode: shipList[0].value,
      datePickerShow: false,
      minDate: dayjs().subtract(100, 'year').toDate(),
      sailDate: isDevelop ? '2020-07-25' : '',
      birthdayPickerShow: false,
      dateOfBirth: '',
      bookingId: isDevelop ? '4739518' : '',
      stateroomNumber: '',
      lastName: isDevelop ? 'CE' : '',
      miniappShow: false
    }
  },

  computed: {
    shipName () {
      return shipList.find(x => x.value === this.shipCode).name
    }
  },

  activated () {
    this.bindOut()
    const { noPopup } = this.$route.query
    if (noPopup !== 'true') {
      this.checkBookingRecordModels()
    }
  },

  methods: {
    async checkBookingRecordModels () {
      showLoading()
      const { data } = await api.getBookingsByBookingOrderId({
        accessToken: this.$store.state.token
      })
      hideLoading()
      this.miniappShow = data && data.bookingRecordModels !== null
    },
    lastNameInput () {
      if (/^[a-zA-Z]+$/.test(this.lastName.trim())) this.lastName = this.lastName.toUpperCase()
    },
    onSubmit () {
      this.$refs.form.validate().then(async success => {
        if (!success) return
        showLoading('提交中...')
        const { errCode, errMsg } = await api.bindBooking(pick(this.$data, ['sailDate', 'bookingId', 'stateroomNumber', 'dateOfBirth', 'lastName', 'shipCode']))
        hideLoading()
        if (errCode === 0) {
          this.getBookingInfo()
        } else {
          showAlert(errMsg || '绑定失败，请稍后重试')
        }
      })
    },
    async getBookingInfo () {
      showLoading()
      const { errCode, errMsg, data } = await api.getBookingInfo()
      if (errCode === 0) await getShoppingCartNum()
      hideLoading()
      if (errCode === 0) {
        showToast.success('绑定成功')
        this.$store.commit('updateBindTicket', {
          ...data,
          bookingRemind: `您的行前预订功能将于 ${dayjs(data.sailDateBegin).subtract(3, 'd').format('YYYY年MM月DD日')} 11:59pm 截止`
        })
        this.$store.commit('setBookingContactInfo', data.bookingContact)
        this.$router.replace('/')
      } else {
        showAlert(errMsg || '绑定失败，请稍后重试')
      }
    },
    async bindOut () {
      showLoading()
      const { errCode, errMsg } = await api.bindOut()
      if (errCode === 0) {
        this.$store.commit('bindout')
      } else {
        showAlert(errMsg)
      }
      hideLoading()
    },
    screenTypeConfirm (val) {
      this.screenTypeChoosed = val
      if (val) {
        this.bookingId = ''
      } else {
        this.stateroomNumber = ''
        this.dateOfBirth = ''
        this.defaultDate2 = new Date()
      }
      this.$refs.form.reset()
    }
  }
}
</script>

<style lang="less" scoped>
.bind-ticket {
  padding: 90px 50px 0;
  .logo {
    display: block;
    width: 92px;
    margin: 0 auto 70px;
  }
  .form-item {
    display: flex;
    align-items: center;
    height: 86px;
    margin-bottom: 20px;
    border: 1Px solid @main-gray6;
    border-radius: 6px;
    background-color: #f6f6f6;
    &.error {
      border-color: @error-color;
    }
    .icon {
      position: relative;
      display: flex;
      align-items: center;
      flex: none;
      padding: 0 28px;
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 0;
        z-index: 1;
        width: 1Px;
        height: 30px;
        margin-top: -15px;
        background-color: @main-gray6;
      }
      img {
        display: block;
        width: 32px;
      }
    }
    .text {
      flex: 1;
      position: relative;
      padding: 0 20px;
      font-size: 30px;
      color: #000f57;
      outline: none;
      border: none;
      background-color: transparent;
    }
    .arrow-down {
      margin-right: 36px;
      font-size: 26px;
      color: #000f57;
    }
    .ipt {
      flex: 1;
      padding: 0 26px;
      border: none;
      outline: none;
      font-size: 30px;
      line-height: 30px;
      color: #000f57;
      background-color: #f6f6f6;
    }
    .error {
      margin-right: 26px;
      font-size: 24px;
      color: @error-color;
    }
  }
  .btn-common {
    width: auto;
    margin-top: 50px;
  }
}
</style>
